import Cookies from "js-cookie";

import { envChecker } from "helpers/envChecker";

import { MAIN_DOMAIN } from "config";
import { EENV } from "constants/index";

export const setCookies = (key: string, value: string) => {
  const { hostname } = new URL(MAIN_DOMAIN);
  Cookies.set(key, value, {
    domain: envChecker({ envs: [EENV.DEV] }) ? undefined : `.${hostname}`,
    expires: 7, //days,
    secure: envChecker({ envs: [EENV.QA, EENV.UAT, EENV.PROD] }),
  });
};
